var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"queue-detail-pay-type-container"},[_c('span',{staticStyle:{"font-size":"20px","font-weight":"bold","margin-bottom":"20px"}},[_vm._v("付款方式")]),_c('queue-item-card',{attrs:{"data-source":_vm.dataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }